import {Component} from "@angular/core";
import {GroupItemModel} from "../group.interface";
import {DialogBase} from "../../../../common/dialog/dialog.base";

@Component({
    templateUrl: "./hierarchy-deletion-dialog.component.html",
    styleUrls: ["./hierarchy-deletion-dialog.component.scss"],
    standalone: false
})
export class HierarchyDeletionDialogComponent extends DialogBase<{ node: GroupItemModel; }, boolean> {
    cancel(): void {
        this.dialogRef.close(false);
    }

    confirmDeletion() {
        this.dialogRef.close(true);
    }
}
